/**
 * T2Band — the T.2 disclaimer on results, download and the catalog (CLAUDE.md
 * §3.5; mission 6 WP03 T022; FR-023, C-003; research §1.10; post-plan S14,
 * T12).
 *
 * Renders `T2_BAND` verbatim inside `DisclaimerBand`, with its one "Rule
 * Catalog" phrase (counsel's B1, memo 2026-10-03) as the link to /app/rules.
 * The split is the only sanctioned way to break a mandatory string. If a Legal Q14
 * rewrite drops the phrase, dev and test throw so the band and its test are
 * updated together; a production build renders the sentence unlinked rather
 * than nothing. Never dismissible.
 */
import { Link } from 'react-router-dom'

import { T2_BAND } from '@/lib/mandatory-copy'

import { DisclaimerBand } from './DisclaimerBand'

const PHRASE = 'Rule Catalog'

export type T2Parts = { before: string; phrase: string; after: string } | { text: string }

export function splitT2(text: string, isProd: boolean): T2Parts {
  const at = text.indexOf(PHRASE)
  if (at < 0) {
    if (!isProd) throw new Error('T2_BAND lost "Rule Catalog" (Legal Q14 rewrite?): update T2Band and its test')
    return { text }
  }
  return { before: text.slice(0, at), phrase: PHRASE, after: text.slice(at + PHRASE.length) }
}

export function T2Band() {
  const parts = splitT2(T2_BAND, import.meta.env['VITE_TRELLIS_ENV'] === 'prod')
  return (
    <DisclaimerBand>
      {'text' in parts ? (
        parts.text
      ) : (
        <>
          {parts.before}
          <Link to="/app/rules" className="text-[var(--color-link)] underline hover:text-[var(--color-link-hover)]">
            {parts.phrase}
          </Link>
          {parts.after}
        </>
      )}
    </DisclaimerBand>
  )
}
